import CommunicationChannels from './components/CommunicationChannels';

export default CommunicationChannels;
